import {startTransition, useEffect, useState} from 'react';

/**
 * This hooks is similar to `useHydrationDone` but should be only used on outer parent components/providers which hosts Suspensed SSR children.
 *
 * Inside Suspense Boundaries, use `useHydrationDone` instead as its value is more accurate as it is scoped to that suspense boundary.
 */
export const useSuspenseSafeHydrationDone = () => {
  const [isHydrationDone, setHydrationDone] = useState(false);
  useEffect(() => {
    startTransition(() => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setHydrationDone(true);
    });
  }, []);

  return isHydrationDone;
};
